import { RegExpValidation } from "../functions/form-validators"

export const RegExpPatterns = {
    email: '^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
    password: '^(?=.*[A-Z])(?=.*[@#$%^&+*!_="\'.])(?=.*[0-9])(?=.*[a-z]).{6,48}$',
    letters: '^[a-zA-Z]*$',
    number: '^[0-9]*$',
    
    elecEquipmentPT: '^PT\\s*000[258]\\s*((\\d{3}\\s*){4}|(\\d{4}\\s*){3})[A-Z]{2}$', //code starting with 'PT', 4 digits('000' + either a '2','5' or '8'), 3*4 digits or 4*3 digits ending with 2 letters, \\s* -> space or no space
    elecEquipmentES: '^ES\\s*(\\d{4}\\s*){4}[A-Z]{2}$', //code starting with 'ES', 4*4 digits ending with 2 letters, \\s* -> space or no space

    ntrlGasEquipmentPT: '^PT\\s*1[6-8]\\d{2}\\s*((\\d{3}\\s*){4}|(\\d{4}\\s*){3})[A-Z]{2}$', //code starting with 'PT', 4 digits ('1' + '6' or '8' + 2 digits), 3*4 digits or 4*3 digits ending with 2 letters, \\s* -> space or no space
    ntrlGasEquipmentES: '^ES\\s*(\\d{4}\\s*){4}[A-Z]{2}$', //code starting with 'ES', 4*4 digits ending with 2 letters, \\s* -> space or no space

    postalCodePT: '^\\d{4}([\\-]\\d{3})$',
    postalCodeES: '^\\d{5}$',
    decimal: '^[0-9]+([,][0-9]+)?$|^[0-9]+([.][0-9]+)?$',

    pt_tin: '^\\d{9}$',
    es_tin: '^[A-Z][0-9]{8}$|^[A-Z][0-9]{7}[A-Z]$|^[0-9]{8}[A-Z]$',
}

export const RegExpPasswordPatternErrors: RegExpValidation[] = [
    new RegExpValidation('PASSWORD_INVALID_UPPERCASE', '(?=.*[A-Z])'),
    new RegExpValidation('PASSWORD_INVALID_SPECIAL_CHARACTERS', '(?=.*[@#$%^&+*!_="\'.])'),
    new RegExpValidation('PASSWORD_INVALID_LOWERCASE', '(?=.*[a-z])'),
    new RegExpValidation('PASSWORD_INVALID_NUMBER', '(?=.*[0-9])'),
]